import React from "react";
import { trackEvent } from "@/lib/analytics";

interface PayPalDonateButtonProps {
  compact?: boolean;
}

const PayPalDonateButton = ({ compact = false }: PayPalDonateButtonProps) => {
  return (
    <form 
      action="https://www.paypal.com/ncp/payment/ME4C75J3VGYKN" 
      method="post" 
      target="_blank" 
      onSubmit={() => trackEvent("donate_clicked", { provider: "paypal" })}
      className={compact ? "inline-block" : "inline-flex flex-col items-center gap-2"}
    >
      <input 
        className={`bg-[#FFD140] hover:bg-[#FFC520] text-black font-bold rounded cursor-pointer transition-colors duration-200 ${
          compact 
            ? "py-1.5 px-3 text-xs min-w-[5rem] h-8" 
            : "py-2 px-4 text-sm min-w-[11.625rem] h-[2.625rem]"
        }`}
        type="submit" 
        value="Donate" 
      />
      {!compact && (
        <>
          <img 
            src="https://www.paypalobjects.com/images/Debit_Credit.svg" 
            alt="Accepted payment methods" 
            className="h-4"
          />
          <section className="text-xs text-muted-foreground flex items-center gap-1">
            Powered by 
            <img 
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg" 
              alt="PayPal" 
              className="h-3.5"
            />
          </section>
        </>
      )}
    </form>
  );
};

export default PayPalDonateButton;